import React from "react"
import styled, { ThemeProvider } from "styled-components"
import Autosuggest from 'react-autosuggest';
import { below } from "../style/functions"
import suburbs from "../data/suburbs.js"
import AutosuggestHighlightMatch from 'autosuggest-highlight/match'
import AutosuggestHighlightParse from 'autosuggest-highlight/parse'

// Imagine you have a list of languages that you'd like to autosuggest.

// Teach Autosuggest how to calculate suggestions for any given input value.
function getSuggestions(value) {
  const escapedValue = escapeRegexCharacters(value.trim());
  if (escapedValue === '') {
    return [];
	}
	

  const regex = new RegExp('^' + escapedValue, 'i');
	var findings = suburbs.filter(language => regex.test(language));
	findings.push('Outside Australia')
	return findings;
}

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion;

// Use your imagination to render suggestions.
function renderSuggestion(suggestion, { query }) {
  const matches = AutosuggestHighlightMatch(suggestion, query);
  const parts = AutosuggestHighlightParse(suggestion, matches);

  return (
    <span>
      {parts.map((part, index) => {
        const className = part.highlight ? 'react-autosuggest__suggestion-match' : null;

        return (
          <span className={className} key={index}>
            {part.text}
          </span>
        );
      })}
    </span>
  );
}

class Example extends React.Component {
  constructor() {
    super();

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: '',
      suggestions: []
    };
	}

  setFocused() {
    this.setState({ fieldStatus: "focused" })
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
		});
		if (newValue.length > 0) {
      this.setState({ fieldStatus: "focused" })
    } else {
      this.setState({ fieldStatus: "empty" })
		}
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const { value, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: '',
      value,
			onChange: this.onChange,
			name: "suburb",
			fieldStatus: "empty"
    };

    // Finally, render it!
    return (
			<Container onFocus={this.setFocused.bind(this)} >
					<Label
          htmlFor="suburb"
          populated={this.state.fieldStatus}
          ref="label"
        >
          Suburb
        </Label>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
			</Container>  
    );
  }
}

const Container = styled.div`
  font-size: ${props => props.theme.fontSize};
  width: 100%;
  height: 2.3em;
  display: block;
  position: relative;
  color: inherit;
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.color};
	${below.mobile`
		height: 2.5em;
	`}
.react-autosuggest__container {
  position: relative;
}

.react-autosuggest__input {
  display: block;
  width: 100%;
  height: 1em;
  line-height: 1em;
  box-sizing: content-box;
  border: none;
  position: relative;
  z-index: 2;
  background-color: transparent;
  border-radius: 0;
  appearance: none;
  outline: none;
  padding: 1.2em 0 0.25em;
  padding-left: ${props => props.theme.paddingLeft};
  color: inherit;

  > option {
    color: #000;
  }

  &:required {
    box-shadow: none; /* for Firefox */
  }
}

.react-autosuggest__input--focused {
  outline: none;
}

.react-autosuggest__input--open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.react-autosuggest__suggestions-container {
  display: none;
}

.react-autosuggest__suggestions-container--open {
  display: block;
  position: absolute;
  top: 30px;
  width: 100%;
  border: 1px solid #aaa;
	color: #000;
  background-color: #fff;
  z-index: 200;;
	max-height: 250px;
	overflow: hidden;
}

.react-autosuggest__suggestions-list {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.react-autosuggest__suggestion {
  cursor: pointer;
  padding: 0.5em 0 0.5em;
	font-size: 1.3rem;
  padding-left: ${props => props.theme.paddingLeft};
	&:nth-of-type(2n) {
		background: #eaeaea;
	}
	
	}

.react-autosuggest__suggestion--highlighted {
  background-color: #ddd;
}
.react-autosuggest__suggestion--highlighted {
  background-color: #ddd;
}

.react-autosuggest__suggestion-match {
  color: #63A37F;
}


`

const Label = styled.label`
  padding-left: ${props => props.theme.paddingLeft};
  position: absolute;
  height: 1em;
  line-height: 1em;
  display: block;
  bottom: 0.3em;
  left: 0;
  z-index: 1;
  transition: all 0.05s;
  color: inherit;
  box-sizing: content-box;
  ${props =>
    props.populated == "focused"
      ? `
      font-size: 0.7em;
      line-height: 1;
      top: 0.5em;
      opacity: 0.8;
    `
      : ``};

  ${below.mobile`
    bottom: 0.8em;
	`} 
      
`

export default Example


// WEBPACK FOOTER //
// ./src/components/autofill.js